import { Label } from '@facephi/ui-react';
import { DEFAULT_LOCALE, translate } from '../../utils/translations';
import { EmptyFilesUpload } from './EmptyFilesUpload';
import { NoFilesUploadedStyles } from './Styles';

type Props = {
  messageType?: 'information' | 'files';
  document?: boolean;
  locale?: string;
};

export const NoFilesUploaded = ({
  messageType = 'files',
  document = false,
  locale = DEFAULT_LOCALE,
}: Props) => {
  const getLabels = () => (
    <>
      <Label fontSize="14" semibold>
        {translate(
          messageType === 'files'
            ? 'No information yet'
            : 'There is not information',
          locale
        )}
      </Label>
      <Label fontSize="12">
        {translate(
          messageType === 'files'
            ? 'Assets will appear here.'
            : 'Please, retry the operation.',
          locale
        )}
      </Label>
    </>
  );

  return (
    <NoFilesUploadedStyles
      flexDirection={document ? 'row' : 'column'}
      justifyContent="center"
      alignItems="center"
      rowGap="1.2"
    >
      <>
        <EmptyFilesUpload small={document ? true : false} />
        {!document ? (
          <>{getLabels()}</>
        ) : (
          <>
            <div style={{ marginLeft: '20px' }}>{getLabels()}</div>
          </>
        )}
      </>
    </NoFilesUploadedStyles>
  );
};
